import ChartsInfo from '../ChartsInfo2';

/**
 * This function is called in makeServiceCall.ts to check whether there is a need to make api call or not.
 * @returns boolean value
 */
export const checkMinRequiredCards = (chartProp: any, chartType: any) => {
  var minReqMet = [];
  ChartsInfo[chartType].dropZones.forEach((zone: any, zoneI: number) => {
    chartProp.chartAxes?.[zoneI]?.fields?.length >= zone?.min
      ? minReqMet.push(true)
      : minReqMet.push(false);
  });

  if (chartType === 'crossTab') {
    if (
      chartProp.chartAxes[1].fields.length > 0 ||
      chartProp.chartAxes[2].fields.length > 0 ||
      chartProp.chartAxes[3].fields.length > 0
    ) {
      minReqMet.push(true);
    } else {
      minReqMet.push(false);
    }
  }

  if (chartType === 'table') {
    if (chartProp.chartAxes[1].fields.length > 0 || chartProp.chartAxes[2].fields.length > 0) {
      minReqMet.push(true);
    } else {
      minReqMet.push(false);
    }
  }

  if (minReqMet.includes(false)) {
    return false;
  } else {
    return true;
  }
};
